/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { CreateRestrictionCheckRequestDTOToJSON, CreateRestrictionCheckResponseDTOFromJSON, CreateSearchResponseDTOFromJSON, DeleteRestrictionChecksRequestDTOToJSON, PaginatedResponseRestrictionCheckItemDTOFromJSON, PaginatedResponseRestrictionCheckSummaryDTOFromJSON, RestrictionCheckSearchRequestDTOToJSON, RestrictionCheckSummaryDTOFromJSON, } from '../models/index';
/**
 *
 */
export class RestrictionCheckControllerApi extends runtime.BaseAPI {
    /**
     */
    async cancelRestrictionCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling cancelRestrictionCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/restriction-checks/{id}/cancel`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => RestrictionCheckSummaryDTOFromJSON(jsonValue));
    }
    /**
     */
    async cancelRestrictionCheck(requestParameters, initOverrides) {
        const response = await this.cancelRestrictionCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createRestrictionCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['createRestrictionCheckRequestDTO'] == null) {
            throw new runtime.RequiredError('createRestrictionCheckRequestDTO', 'Required parameter "createRestrictionCheckRequestDTO" was null or undefined when calling createRestrictionCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/restriction-checks`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRestrictionCheckRequestDTOToJSON(requestParameters['createRestrictionCheckRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateRestrictionCheckResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async createRestrictionCheck(requestParameters, initOverrides) {
        const response = await this.createRestrictionCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createSearchFromRestrictionCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling createSearchFromRestrictionCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/restriction-checks/{id}/search`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RestrictionCheckSearchRequestDTOToJSON(requestParameters['restrictionCheckSearchRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSearchResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async createSearchFromRestrictionCheck(requestParameters, initOverrides) {
        const response = await this.createSearchFromRestrictionCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteRestrictionCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteRestrictionCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/restriction-checks/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteRestrictionCheck(requestParameters, initOverrides) {
        await this.deleteRestrictionCheckRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteRestrictionChecksRaw(requestParameters, initOverrides) {
        if (requestParameters['deleteRestrictionChecksRequestDTO'] == null) {
            throw new runtime.RequiredError('deleteRestrictionChecksRequestDTO', 'Required parameter "deleteRestrictionChecksRequestDTO" was null or undefined when calling deleteRestrictionChecks().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/restriction-checks`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteRestrictionChecksRequestDTOToJSON(requestParameters['deleteRestrictionChecksRequestDTO']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteRestrictionChecks(requestParameters, initOverrides) {
        await this.deleteRestrictionChecksRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getRestrictionCheckRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getRestrictionCheck().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/restriction-checks/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => RestrictionCheckSummaryDTOFromJSON(jsonValue));
    }
    /**
     */
    async getRestrictionCheck(requestParameters, initOverrides) {
        const response = await this.getRestrictionCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listRestrictionCheckItemsRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling listRestrictionCheckItems().');
        }
        const queryParameters = {};
        if (requestParameters['outcome'] != null) {
            queryParameters['outcome'] = requestParameters['outcome'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/restriction-checks/{id}/items`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseRestrictionCheckItemDTOFromJSON(jsonValue));
    }
    /**
     */
    async listRestrictionCheckItems(requestParameters, initOverrides) {
        const response = await this.listRestrictionCheckItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listRestrictionChecksRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['marketplace'] != null) {
            queryParameters['marketplace'] = requestParameters['marketplace'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/restriction-checks`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseRestrictionCheckSummaryDTOFromJSON(jsonValue));
    }
    /**
     */
    async listRestrictionChecks(requestParameters = {}, initOverrides) {
        const response = await this.listRestrictionChecksRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ListRestrictionCheckItemsOutcomeEnum = {
    Unrestricted: 'UNRESTRICTED',
    ApprovalRequired: 'APPROVAL_REQUIRED',
    NotEligible: 'NOT_ELIGIBLE',
    NotFound: 'NOT_FOUND',
    Error: 'ERROR'
};
/**
 * @export
 */
export const ListRestrictionChecksMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
